import { DOCUMENT } from '@angular/common';
import { APP_ID, CSP_NONCE, Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { ɵSharedStylesHost } from '@angular/platform-browser';

@Injectable()
export class CustomStylesHostService extends ɵSharedStylesHost {
  private readonly REM_BASE = 10;
  private transformStyleCache = new Map<string, string>();

  constructor(
    @Inject(DOCUMENT) doc: Document,
    @Inject(APP_ID) appId: string,
    @Inject(CSP_NONCE) @Optional() nonce?: string | null,
    @Inject(PLATFORM_ID) platformId: object = {},
  ) {
    super(doc, appId, nonce, platformId);
    this['hosts'].clear();
  }

  public addStyles(styles: string[], urls: string[]): void {
    const transformedStyles = styles.map(style => {
      const cachedStyle = this.transformStyleCache.get(style);
      if (cachedStyle) {
        return cachedStyle;
      }

      const transformedStyle = this.remToPX(style);
      this.transformStyleCache.set(style, transformedStyle);
      return transformedStyle;
    });
    super.addStyles(transformedStyles, urls);
  }

  public removeStyles(styles: string[], urls: string[]): void {
    const transformedStyles = styles.map(style => this.transformStyleCache.get(style) ?? style);
    super.removeStyles(transformedStyles, urls);
  }

  private remToPX(style: string): string {
    return style.replace(
      /(((\d+)|(\.\d+)|(\d+\.\d+))rem)/g,
      match => `${parseFloat(match) * this.REM_BASE}px`,
    );
  }
}
